import { getTypographyMetric, getTypographyMetricOverride } from '../../../../../../../../helpers';
import { useTheme } from 'styled-components';
import { Button, Flex, Icon, SideDrawer } from 'front-commons/ds/components';
import { Typography } from 'hype-ds';
import { usePosSelectorDrawer } from './hooks/usePosSelectorDrawer';
import { Content } from '../../../../components/Content';

export function PosSelectorDrawer() {
	const { fontSizes } = useTheme();

	const {
		loading,
		isSimulated,
		selectedPos,
		storedPosList,
		hasMoreThanFourPos,
		handleSearch,
		handleSeeMore,
		posList,
		inputProps,
		search,
		searchLoading,
		handleCloseDrawer,
		isSinglePos,
		handleChangePos,
	} = usePosSelectorDrawer();

	return (
		<SideDrawer
			open
			side="bottom"
			padding="0px"
			onClose={handleCloseDrawer}
			maxHeight={isSinglePos ? '128px' : '600px'}
			borderRadius="24px 24px 0 0"
		>
			<Flex
				maxHeight="90vh"
				height="100%"
				padding="1rem"
				gap="0"
				direction="column"
				justifyContent="space-between"
				position="relative"
				raw={{ overflowY: 'auto' }}
			>
				<Flex gap="0" direction="column">
					<Flex justifyContent="space-between" alignItems="center">
						<Flex
							raw={{
								"[data-header-text='PosSelectorDrawer-text-1']": {
									display: 'inline',
									fontSize: getTypographyMetricOverride(fontSizes['14']),
									lineHeight: getTypographyMetricOverride(fontSizes['20']),
								},
							}}
							gap="8px"
							alignItems="center"
						>
							<Icon name="swap_vert" color="--neutral-black" size="16px" />
							<Typography
								textAlign="inherit"
								fontSize={getTypographyMetric(fontSizes['14'])}
								fontWeight="400"
								lineHeight={getTypographyMetric(fontSizes['20'])}
								color="--greys-900"
								data-header-text="PosSelectorDrawer-text-1"
							>
								Trocar farmácia
							</Typography>
						</Flex>

						<Button onClick={handleCloseDrawer} variant="none">
							<Icon name="close" color="--text-link" size="16px" />
						</Button>
					</Flex>

					<Flex
						marginTop="1rem"
						gap="1rem"
						direction="column"
						raw={{
							"[data-component='Typography']:not([data-header-pos-label])": { display: 'inline' },
							'[data-header-pos-label]': {
								cursor: 'pointer',
								fontSize: getTypographyMetricOverride(fontSizes['16']),
								lineHeight: getTypographyMetricOverride(fontSizes['24']),
							},
							"[data-header-text='PosList-metric-1']": {
								fontSize: getTypographyMetricOverride(fontSizes['16']),
								lineHeight: getTypographyMetricOverride(fontSizes['24']),
							},
							"[data-header-pos-label='selected']": { cursor: 'not-allowed' },
							'input::placeholder': { color: 'var(--text-secondary)' },
						}}
					>
						<Content
							disablePosSelecting={loading}
							onChangePos={handleChangePos}
							handleSeeMore={handleSeeMore}
							hasMoreThanFourPos={hasMoreThanFourPos}
							inputProps={inputProps}
							isSimulated={isSimulated}
							loading={searchLoading}
							posList={posList}
							search={search}
							selectedPosId={selectedPos?.pointOfSaleId || ''}
							storedPosList={storedPosList}
						/>
					</Flex>
				</Flex>

				{!isSinglePos && (
					<Flex
						raw={{
							"[data-header-text='PosSelectorDrawer-text-2']": {
								display: 'inline',
								fontSize: getTypographyMetricOverride(fontSizes['16']),
								lineHeight: getTypographyMetricOverride(fontSizes['24']),
							},
						}}
						as={Button}
						display="flex"
						gap="8px"
						alignItems="center"
						justifyContent="center"
						position="relative"
						noShrink={true}
						width="100%"
						marginTop="1.5rem"
						onClick={handleSearch}
					>
						<Typography
							textAlign="inherit"
							fontSize={getTypographyMetric(fontSizes['16'])}
							fontWeight="600"
							lineHeight={getTypographyMetric(fontSizes['24'])}
							color="--hympar-blue-700"
							data-header-text="PosSelectorDrawer-text-2"
						>
							Buscar farmácia
						</Typography>
					</Flex>
				)}
			</Flex>
		</SideDrawer>
	);
}
